var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#73AF00"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    style: {
      fill: "#F5F5F5"
    },
    width: 256,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M321.033,207.015l-23.36,30.559l-36.475-12.209c-2.04-0.683-3.774,1.624-2.553,3.394l21.845,31.66   l-22.883,30.917c-1.28,1.729,0.378,4.091,2.439,3.477l36.861-10.992l22.333,31.317c1.249,1.751,4.008,0.905,4.06-1.245   l0.936-38.453l36.686-11.562c2.051-0.647,2.099-3.532,0.07-4.246l-36.282-12.773l0.34-38.463   C325.069,206.243,322.34,205.306,321.033,207.015z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M280.217,348.541c-51.068,0-92.495-41.427-92.495-92.541c0-51.021,41.427-92.54,92.495-92.54   c19,0,36.522,5.844,51.124,15.734c2.236,1.515,4.788-1.424,2.916-3.371c-21.823-22.689-52.711-36.531-86.956-35.362   c-58.836,2.008-107.544,49.18-111.303,107.93c-4.306,67.294,48.978,123.217,115.319,123.217c32.679,0,62.048-13.662,83.022-35.506   c1.853-1.93-0.705-4.824-2.92-3.322C316.802,342.69,299.251,348.541,280.217,348.541z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/dz.58b870a003c97246967bd523e9a25aa9.svg";
export { ForwardRef as ReactComponent };